import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c47b192"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "cw-avatar-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (this.showOverall)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (this.showAvatar)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cw-avatar-icon",
              style: _normalizeStyle({ 'background-image': 'url(' + this.downloadUrl + ')' })
            }, null, 4))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(this.initials), 1))
      ], 64))
    : _createCommentVNode("", true)
}